// JS
import React, { /*useEffect, useRef,*/ useState, Suspense } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { randomId } from '../shared/utils';

// COMPS
import { LoadingSpinner } from '../LoadingSpinner';

/* SIZE GUIDES - PIM */
import { ProductSizesTable } from '../shared/pimSizeGuideData';
import { ProductSizesPopupImage } from '../shared/pimSizeGuideData';

// UNIQUE ID
const uniqueId = randomId();

// COMPONENT
const ProductSizesGuide = ({
  data,
  setProdSku,
  sizeSelect,
  setSizeSelect,
  sizeGuideSelect,
  setSizeGuideSelect,
  setMiniBasketSize,
  setMiniBasketProdSku,
  setAtbButtonTxt,
  isMobile,
  productSize,
  setProductSize
}) => {
  const [cm, setCm] = useState(true);

  /* React Tab - Functionality */
  const TabPanelPosition = () => {
    return (
      <div className="size-guide-pim-tab-panel-wrapper">
        <TabPanel>
          <ProductSizesTable data={data} cm={cm} productSize={productSize} />
        </TabPanel>
        <TabPanel>
          <ProductSizesTable data={data} productSize={productSize} />
        </TabPanel>
      </div>
    );
  };

  /* Alternative Tab - Functionality
  const [activeTab, setActiveTab] = useState(0);
  const [tabLeft, setTabLeft] = useState(0);
  const [tabWidth, setTabWidth] = useState(0);
  const tabRef = useRef([]);

  const tabData = [
    {
      measurement: 'CM',
      table: (
        <div className="size-guide-pim-tab-panel-wrapper">
          <ProductSizesTable data={data} cm={cm} productSize={productSize} />
        </div>
      )
    },
    {
      measurement: 'Inch',
      table: (
        <div className="size-guide-pim-tab-panel-wrapper">
          <ProductSizesTable data={data} productSize={productSize} />
        </div>
      )
    }
  ];

  useEffect(() => {
    function setTabPosition() {
      const currentTab = tabRef.current[activeTab];
      setTabLeft(currentTab?.offsetLeft ?? 0);
      setTabWidth(currentTab?.clientWidth ?? 0);
    }

    setTabPosition();
    window.addEventListener('resize', setTabPosition);

    return () => window.removeEventListener('resize', setTabPosition);
  }, [activeTab]);
  */

  return (
    <div key={1} id={'size-guide-pim ' + uniqueId} className="size-guide-pim">
      {isMobile && <div className="size-guide-pim-heading">Size Guide</div>}
      <Suspense
        fallback={
          <div className="size-guide-pim-loading-spinner">
            <LoadingSpinner />
          </div>
        }
      >
        <ProductSizesPopupImage
          data={data}
          sizeGuideSelect={sizeGuideSelect}
          cm={cm}
          productSize={productSize}
        />
      </Suspense>
      <div className="size-guide-pim-details">
        {!isMobile && <div className="size-guide-pim-heading">Size Guide</div>}
        <div className="size-guide-pim-sizes">
          <div className="size-guide-pim-sizes-heading">
            Sizes
            {data.product.attributes &&
              data.product.attributes.modelwears !== undefined &&
              data.product.attributes.modelwears[0].includes('size') && (
                <div className="size-guide-pim-model-wears">
                  {data.product.attributes.modelwears}
                </div>
              )}
          </div>
          <div className="size-guide-pim-sizes-wrapper">
            {data.product.options.map((sizes, i) => (
              <span key={'size-key[' + i + ']'}>
                {sizes.attributes && (
                  <div
                    tabIndex={0}
                    role="button"
                    aria-pressed={sizes.sku === sizeSelect ? 'true' : 'false'}
                    aria-label="Select a size"
                    className={
                      sizes.sku === sizeSelect
                        ? 'size-guide-pim-sizes-selector selected'
                        : 'size-guide-pim-sizes-selector'
                    }
                    onClick={() => {
                      setSizeSelect(sizes.sku);
                      setProdSku(sizes.stock >= 1 ? sizes.sku : '');
                      setSizeGuideSelect(sizes.attributes.non_mapped_size[0]);
                      setMiniBasketSize(sizes.attributes.non_mapped_size[0]);
                      setMiniBasketProdSku(sizes.sku);
                      setAtbButtonTxt(
                        sizes.stock >= 1 ? 'Add to bag' : 'Select Size'
                      );
                      setProductSize(i);
                    }}
                  >
                    {sizes.attributes.non_mapped_size[0]}
                  </div>
                )}
              </span>
            ))}
          </div>
        </div>
        <div className="size-guide-pim-measurements">
          <div className="size-guide-pim-measurements-title">
            Measurements : <span>{sizeGuideSelect}</span>
          </div>
          <Tabs>
            {!isMobile && TabPanelPosition()}
            <div className="size-guide-pim-tab-list">
              Units
              <TabList className="size-guide-pim-tab-selector">
                <Tab
                  onClick={() => {
                    setCm(true);
                  }}
                >
                  CM
                </Tab>
                <Tab
                  onClick={() => {
                    setCm(false);
                  }}
                >
                  Inch
                </Tab>
              </TabList>
            </div>
            {isMobile && TabPanelPosition()}
          </Tabs>
          {/* Alternative Tab - Functionality
            <div className="react-tabs">
              {!isMobile && tabData[activeTab].table}
              <div className="size-guide-pim-tab-list">
                Units
                <div className="size-guide-pim-tab-selector">
                  {tabData.map((tab, i) => {
                    return (
                      <div
                        key={i}
                        className="size-guide-pim-tab-selector-button"
                        ref={(el) => (tabRef.current[i] = el)}
                        onClick={() => {
                          setActiveTab(i);
                          setCm(i === 0 ? true : false);
                        }}
                      >
                        {tab.measurement}
                      </div>
                    );
                  })}
                  <span style={{ left: tabLeft, width: tabWidth }} />
                </div>
              </div>
              {isMobile && tabData[activeTab].table}
            </div>
          */}
        </div>
      </div>
    </div>
  );
};

export default ProductSizesGuide;
